/* eslint-disable no-console */

import Fire from 'assets/images/Fire.svg';
import flagCa from 'assets/images/CAD.svg';
import flagUs from 'assets/images/US.svg';
import check from 'assets/images/Check.svg';
import check2 from 'assets/images/checkmark2.svg';
import chevron from 'assets/images/ChevronDown.svg';
import close from 'assets/images/Close.svg';
import closeSkinny from 'assets/images/CloseSkinny.svg';
import redClose from 'assets/images/RedClose.svg';
import downArrow from 'assets/images/Down.svg';
import download from 'assets/images/Download.svg';
import downTriangle from 'assets/images/DownTriangle.svg';
import ellipse from 'assets/images/Ellipse.svg';
import gain from 'assets/images/Gain.svg';
import info from 'assets/images/Info.svg';
import loss from 'assets/images/Loss.svg';
import rangeSelection from 'assets/images/RangeSelection.svg';
import upArrow from 'assets/images/Up.svg';
import checkDark from 'assets/images/CheckDark.svg';
import document from 'assets/images/PDF.svg';
import morningStar from 'assets/images/MorningstarFilled.svg';
import morningStarOpen from 'assets/images/MorningstarOutlined.svg';
import outOfApp from 'assets/images/OutofApp.svg';
import radio from 'assets/images/RadioOff.svg';
import radioSelected from 'assets/images/RadioOn.svg';
import redLeftArrow from 'assets/images/RedLeft.svg';
import redRightArrow from 'assets/images/RedRight.svg';
import redSearch from 'assets/images/RedSearch.svg';
import search from 'assets/images/Search.svg';
import refresh from 'assets/images/Refresh.svg';
import bullHorn from 'assets/images/bullHorn.svg';
import clipboard from 'assets/images/clipboard.svg';
import warning from 'assets/images/ErrorWarning.svg';
import warningOutline from 'assets/images/ErrorWarning2.svg';
import grayClose from 'assets/images/GrayClose.svg';
import bullHornTransparent from 'assets/images/BullHornTransparent.svg';
import reports from 'assets/images/Reports.svg';
import bell from 'assets/images/AlertsBell.svg';

/**
 * A React component for returning svg images.  Note: You must update this file when we
 * add additional images.
 *
 * @param {String} [iconName] The name of the icon - which are imported from ../images
 * @type {PureFunctionComponent}
 */

const icons = {
	Fire, // default icon that will show if the icon name passed in does not match any available.

	bullHorn,
	check,
	check2,
	checkDark,
	chevron,
	close,
	closeSkinny,
	clipboard,
	redClose,
	downArrow,
	download,
	downTriangle,
	ellipse,
	flagCa,
	flagUs,
	gain,
	info,
	loss,
	document,
	morningStar,
	morningStarOpen,
	outOfApp,
	rangeSelection,
	radio,
	radioSelected,
	refresh,
	redLeftArrow,
	redRightArrow,
	redSearch,
	search,
	upArrow,
	warning,
	warningOutline,
	grayClose,
	bullHornTransparent,
	reports,
	bell
};

const iconImage = iconName => {
	let icon = icons[iconName];
	if (!icon) {
		icon = icons.Fire;
		console.error(`Invalid prop: ${iconName}.
			propName: iconName.
			componentName: Icon.
			Possible values: ${Object.keys(icons)}`);
	}
	return icon;
};

export {
	icons,
	iconImage
};
